export default [
  {
    path: '/community_list',
    name: 'community_list',
    meta: { title: '社群列表', keepAlive: true },
    component: () => import('@/views/community/community_list.vue')
  },
  {
    path: '/community_add',
    name: 'community_add',
    meta: { title: '社群编辑' },
    component: () => import('@/views/community/community_add.vue')
  },
  {
    path: '/community_member_list',
    name: 'community_member_list',
    meta: { title: '社群成员列表' },
    component: () => import('@/views/community/community_member_list.vue')
  },
  {
    path: '/community_category',
    name: 'community_category',
    meta: { title: '社群分类' },
    component: () => import('@/views/community/community_category.vue')
  },
  {
    path: '/community_industry',
    name: 'community_industry',
    meta: { title: '社群行业' },
    component: () => import('@/views/community/community_industry.vue')
  },
  {
    path: '/community_tag',
    name: 'community_tag',
    meta: { title: '社群标签' },
    component: () => import('@/views/community/community_tag.vue')
  }
]
